import { render, staticRenderFns } from "./SideMenu.vue?vue&type=template&id=1f9b0126&scoped=true"
import script from "./SideMenu.vue?vue&type=script&lang=js"
export * from "./SideMenu.vue?vue&type=script&lang=js"
import style0 from "./SideMenu.vue?vue&type=style&index=0&id=1f9b0126&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1f9b0126",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/opt/atlassian/pipelines/agent/build/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('1f9b0126')) {
      api.createRecord('1f9b0126', component.options)
    } else {
      api.reload('1f9b0126', component.options)
    }
    module.hot.accept("./SideMenu.vue?vue&type=template&id=1f9b0126&scoped=true", function () {
      api.rerender('1f9b0126', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/ui/components/SideMenu.vue"
export default component.exports